import React from "react"
import { useIntl } from "react-intl"
import DelegacaoConsultaComponent from "./delegacao.consulta.component"

const DelegacaoLaminasComponentInlt = () => {
    const intl = useIntl()
    return (
        <DelegacaoConsultaComponent intl={intl}></DelegacaoConsultaComponent>
    )
}

export default DelegacaoLaminasComponentInlt


// WEBPACK FOOTER //
// ./src/pages/histologia/common/delegacao_laminas/delegacao-component-intl.js